import React, {useState, useEffect, useRef} from 'react';
import {useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Dropdown} from "primereact/dropdown";
import axios from "axios";
import moment from "moment/moment";
import {Panel} from "primereact/panel";

import ReceiptPdfViewerComponent from '../../../2.1/finance/receipt/ReceiptPdfViewerComponent';

const InventorydocumentShowComponent = (props) => {

  const {t} = props;
  const {entity, id} = useParams();
  const isInventoryDocumentEntity = entity === 'inventory-document' || entity === 'transfer-supplier' ||
    props.entity === 'inventory-document' || props.entity === 'transfer-supplier';
  const [loading, setLoading] = useState(false);
  const [loadingMaterials, setLoadingMaterials] = useState(false);
  const [loadingItems, setLoadingItems] = useState(false);
  const [file, setFile] = useState(false);
  const [fileUrl, setFileUrl] = useState(null);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [fileLoading, setFileLoading] = useState(false);
  const [formData, setFormData] = useState({
    date: moment.utc(new Date()).format('YYYY-MM-DD HH:mm:ss'),
    items: []
  });
  const [warehouses, setWarehouses] = useState([]);
  const [warehouseLocations, setWarehouseLocations] = useState([]);
  const [materials, setMaterials] = useState([]);
  const [items, setItems] = useState([]);

  const currentView = window.App.urlVars().view || props.view;
  const isInventoryCountView = currentView === 'inventory_count';

  const selectedWarehouseValue = isInventoryCountView
    ? formData?.warehouse_from
    : formData?.warehouse_to;

  const selectedWarehouseId = selectedWarehouseValue?.id || selectedWarehouseValue || null;
  const selectedWarehouse = warehouses.find(item => item.id === selectedWarehouseId);
  const showWarehouseLocationToColumn = !!selectedWarehouse?.warehouse_location_required;

  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'id',
    sortOrder: -1,
  });

  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoadingMaterials(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      let query = window.App.transformQueryParams(lazyParams)
      if(isInventoryDocumentEntity) {
        apiCall('GET', '/api/v2/material' + query)
          .then(response => {
            setTotalRecords(response.data.data.total_item_count);
            setMaterials(response.data.data.items)
          })
          .catch(error => {
            window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          })
          .finally(() => {
            setLoadingMaterials(false);
          })
      }
      if(entity === 'purchase-order') {
        apiCall('GET', '/api/v2/purchase-order-item' + query + '&search[purchase_order][operator]=%3D&search[purchase_order][value]=' + id)
          .then(response => {
            setTotalRecords(response.data.data.total_item_count);
            setMaterials(response.data.data.items)
          })
          .catch(error => {
            window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          })
          .finally(() => {
            setLoadingMaterials(false);
          })
      }
    }, Math.random() * 1000 + 250);
  }

  const [totalRecordsItems, setTotalRecordsItems] = useState(0);
  const [rowsItems, setRowsItems] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const [lazyParamsItems, setLazyParamsItems] = useState({
    first: 0,
    rows: rowsItems,
    page: 0,
    sortField: 'id',
    sortOrder: -1,
    filters: {
      purchase_order_request: {value: id, matchMode: 'equals'}
    }
  });

  let loadLazyTimeoutItems = null;
  const loadLazyDataItems = () => {
    setLoadingItems(true);
    if (loadLazyTimeoutItems) {
      clearTimeout(loadLazyTimeoutItems);
    }
    loadLazyTimeoutItems = setTimeout(() => {
      let query = window.App.transformQueryParams(lazyParamsItems)
      apiCall('GET', '/api/v2/purchase-order-request-item' + query)
        .then(response => {
          setTotalRecordsItems(response.data.data.total_item_count);
          setItems(response.data.data.items)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoadingItems(false);
        })
    }, Math.random() * 1000 + 250);
  }

  const apiCall = (method, url, data, extra = {}) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      },
      ...extra,
    })
  }

  useEffect(() => {
    let alive = true;
    let createdUrl = null;
    const download = async () => {
      if (!file || typeof file !== 'object' || !file.id) {
        setFileUrl(null);
        setFileLoading(false);
        return;
      }
      setFileLoading(true);
      try {
        const response = await apiCall(
          'GET',
          `/api/v2/file/${file.id}/download`,
          null,
          { responseType: 'blob' }
        );
        const blob = new Blob([response.data], { type: 'application/pdf' });
        createdUrl = URL.createObjectURL(blob);
        if (alive) {
          setFileUrl(createdUrl);
        }
      } catch (error) {
        if (alive) {
          setFileUrl(null);
        }
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      } finally {
        if (alive) {
          setFileLoading(false);
        }
      }
    };
    download();
    return () => {
      alive = false;
      if (createdUrl) URL.revokeObjectURL(createdUrl);
    };
  }, [file]);

  useEffect(() => {
    loadLazyData()
  }, [lazyParams])

  useEffect(() => {
    loadLazyDataItems()
  }, [lazyParamsItems])

  useEffect(() => {
    const wid = formData?.warehouse_to?.id || formData?.warehouse_to;
    const warehouse = warehouses.find(item => item.id === wid);
    if (!wid || !warehouse?.warehouse_location_required) {
      setWarehouseLocations([]);
      return;
    }
    if (formData.warehouse_to) {
      apiCall('GET', '/api/v2/warehouse-location?search[warehouse][operator]==&search[warehouse][value]=' + wid + '&search[type][operator]==&search[type][value]=PICK')
        .then(response => {
          setWarehouseLocations(response.data.data.items)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
    }
  }, [formData.warehouse_to, formData.warehouse_from, warehouses, isInventoryCountView])

  useEffect(() => {
    apiCall('GET', '/api/v2/warehouse')
      .then(response => {
        setWarehouses(response.data.data.items)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    if (id && !window.App.urlVars().create) {
      setLoading(true);
      apiCall('get', '/api/v2/inventory-document/' + (window.App.urlVars().inventoryDocumentId ?? id))
        .then(response => {
          const data = response.data.data;
          setFormData(data);
          setFile(data?.file || null);
          setDataLoaded(true);
          if (props.onLoaded) {
            props.onLoaded(data);
          }
        })
        .catch(error => {
          setDataLoaded(true);
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [])

  return (
    <div className={"inventorydocument-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
          <div className={"p-grid"}>
            {(props.view === 'header' || !props.view) && (
            <div className={"p-grid p-mb-2 p-ai-start"} style={{ columnGap: '1.25rem', rowGap: '0.75rem' }}>
              <div className={"p-col"}>
                <small className={"p-text-uppercase"}>{props.t('columnFulfillmentDate')}</small>
                <p className={"p-mt-0 p-mb-0 p-text-bold"}>
                  {formData?.date ? formData.date.slice(0, 10) : ''}
                </p>
              </div>
              <div className={"p-col"}>
                <small className={"p-text-uppercase"}>
                  {isInventoryCountView ? props.t('columnWarehouse') : props.t('targetWarehouse')}
                </small>
                <p className={"p-mt-0 p-mb-0 p-text-bold"}>
                  {isInventoryCountView ? formData?.warehouse_from?.name : formData?.warehouse_to?.name}
                </p>
              </div>
              <div className={"p-col"}>
                <small className={"p-text-uppercase"}>{props.t('columnDescription')}</small>
                <p className={"p-mt-0 p-mb-0 p-text-bold"}>
                  {formData?.description}
                </p>
              </div>
              <div className={"p-col"}>
                <small className={"p-text-uppercase"}>{props.t('columnPartner')}</small>
                <p className={"p-mt-0 p-mb-0 p-text-bold"}>
                  {formData?.partner?.name}
                </p>
              </div>
              {isInventoryDocumentEntity &&
              <div className="p-col" hidden={!formData?.shipping_address_snapshot}>
                <small>{props.t('fieldDeliveryAddress')}</small>
                <div className="p-text-bold">{[formData?.shipping_address_snapshot?.country_code, formData?.shipping_address_snapshot?.postal_code, formData?.shipping_address_snapshot?.city, formData?.shipping_address_snapshot?.detail].filter(Boolean).join(' ')}</div>
              </div>}
              {isInventoryDocumentEntity &&
              <div className={"p-col"}>
                <small className={"p-text-uppercase"}>{props.t('columnSerialNumber')}</small>
                <p className={"p-mt-0 p-mb-0 p-text-bold"}>
                  {formData?.document_number}
                </p>
              </div>
              }
            </div>
            )}
            {/* <div className={"p-col-12 p-lg-4"}>
              <div className="p-field p-fluid">
                <label htmlFor="location">{props.t('columnFulfillmentDate')}</label>
                <span className="p-d-block fake-input">
                  {formData?.date ? formData.date.slice(0, 10) : ''}
                </span>
              </div>
            </div>
            <div className={"p-col-12 p-lg-4"}>
              <div className="p-field p-fluid">
                <label htmlFor="location">{t('targetWarehouse')}</label>
                <span className="p-d-block fake-input">
                  {formData?.warehouse_to?.name}
                </span>
              </div>
            </div>
            <div className={"p-col-12 p-lg-4"}>
            </div>
            <div className={"p-col-12 p-lg-4"}>
              <div className="p-field p-fluid">
                <label htmlFor="location">{t('columnDescription')}</label>
                <span className="p-d-block fake-input">
                  {formData?.description}
                </span>
              </div>
            </div>
            <div className={"p-col-12 p-lg-6"}>
              <div className="p-field p-fluid">
                <label htmlFor="location">{t('columnPartner')}</label>
                <span className="p-d-block fake-input">
                  {formData?.partner?.name}
                </span>
              </div>
            </div>
            {isInventoryDocumentEntity &&
              <div className={"p-col-12 p-lg-4"}>
                <div className="p-field p-fluid">
                  <label htmlFor="location">{t('columnSerialNumber')}</label>
                  <span className="p-d-block fake-input">
                  {formData?.document_number}
                </span>
                </div>
              </div>
            } */}
          </div>

          <div className={"p-grid p-mt-3"}>
            {/* <div className={"p-col-12 p-lg-6"}>
              <Panel>
                <h4 className={"p-mt-0"}>Termékek</h4>
                {entity === 'transfer-supplier' &&
                  <DataTable
                    emptyMessage={props.t('noResults')}
                    size={"small"}
                    value={materials} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
                    onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                    onFilter={onFilter} filters={lazyParams.filters} lazy
                    paginatorTemplate={pager} rows={rows} emptyMessage={props.t('noResults')}
                    autoLayout={true}
                    filterDisplay="row"
                    responsiveLayout="scroll"
                    stripedRows
                    ref={dt}
                    dataKey="id"
                  >
                    <Column field="name" header="Megnevezés" sortable filter
                            body={(rowData) => {
                              return (
                                <div className={"added-" + (formData.items.some(item => item.material === rowData.id) || Boolean(formData?.id))}>
                                  {rowData.name}
                                </div>
                              )
                            }}
                    ></Column>
                  </DataTable>
                }
                {entity === 'purchase-order' &&
                  <DataTable
                    emptyMessage={props.t('noResults')}
                    size={"small"}
                    value={materials} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
                    onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                    onFilter={onFilter} filters={lazyParams.filters} lazy
                    paginatorTemplate={pager} rows={rows} emptyMessage={props.t('noResults')}
                    autoLayout={true}
                    filterDisplay="row"
                    responsiveLayout="scroll"
                    stripedRows
                    ref={dt}
                    dataKey="id"
                  >
                    <Column field="name" header="Megnevezés" sortable filter
                            body={(rowData) => {
                              return (
                                <div>
                                  {rowData?.material?.name}
                                </div>
                              )
                            }}
                    ></Column>
                  </DataTable>
                }
              </Panel>
            </div> */}
            
            {/* {(props.view === 'items' || !props.view) && (
            <div className={"p-col-12 p-lg-12"}>
              <Panel>
                <h4 className={"p-mt-0"}>Átvett termékek</h4>
                <DataTable
                  emptyMessage={props.t('noResults')}
                  size={"small"}
                  value={formData.items} paginator first={lazyParamsItems.first} totalRecords={totalRecordsItems}
                  onPage={onPageItems}
                  onSort={onSortItems} sortField={lazyParamsItems.sortField} sortOrder={lazyParamsItems.sortOrder}
                  onFilter={onFilterItems} filters={lazyParamsItems.filters} lazy
                  paginatorTemplate={pagerItems} rows={rowsItems} emptyMessage={props.t('noResults')}
                  autoLayout={true}
                  filterDisplay="row"
                  responsiveLayout="scroll"
                  stripedRows
                  ref={dtItems}
                  dataKey="id"
                >
                  <Column header="Megnevezés" sortable filter
                          body={(rowData) => {
                            if (formData.id) {
                              return (
                                <>
                                  {rowData?.material?.name}
                                </>
                              )
                            } else {
                              let material = materials.find(item => item.id === rowData.material)
                              return (
                                <>
                                  {material.name || material?.material?.name}
                                </>
                              )
                            }
                          }}
                  ></Column>
                  <Column field="quantity" header={props.t('quantity')} sortable filter
                          body={(rowData) => {
                            if (formData.id) {
                              return (
                                <>
                                  {Number(rowData?.quantity)} {rowData?.unit?.name}
                                </>
                              )
                            }
                          }}></Column>
                  <Column header={props.t('targetWarehouseLocation')} body={(rowData) => {
                    if (formData.id) {
                      return (
                        <>
                          {rowData?.warehouse_location_to?.code}
                        </>
                      )
                    }
                  }}></Column>
                </DataTable>
              </Panel>
            </div>
            )} */}

            {props.view === 'file' && (
              <div className="p-col-12">
                {(!dataLoaded || fileLoading) ? (
                  <div className="p-text-center p-p-5">
                    <i className="pi pi-spin pi-spinner p-mr-2" />
                    {props.t('loading')}
                  </div>
                ) : fileUrl ? (
                  <ReceiptPdfViewerComponent
                    key={fileUrl}
                    file={fileUrl}
                    height={Math.max(600, window.innerHeight - 260)}
                  />
                ) : (
                  <div className="p-text-center p-p-5">
                    {props.t('noAttachedDocumentImage')}
                  </div>
                )}
              </div>
            )}

            {props.view === 'preview' && (
              <div style={{width: '21cm', minHeight: '29cm', margin: 'auto'}}>
                <Panel className={"p-mx-auto p-p-5"} style={{width: '21cm', minHeight: '29cm', borderRadius: '0'}}>
                  <div className={"p-grid"}>
                    <div className={"p-col-12 p-lg-6"}>
                      <h1 className={"p-m-0 p-text-uppercase p-text-normal"}>
                        {isInventoryCountView
                          ? props.t('inventoryCount')
                          : isInventoryDocumentEntity
                            ? props.t('goodsReceipt')
                            : props.t('stockDocument')}
                      </h1>
                      <small className={"p-text-uppercase"}>{props.t('columnFulfillmentDate')}</small>
                      <div className={"p-text-bold"}>
                        {formData?.date ? window.App.formatDateValue(formData.date) : '—'}
                      </div>
                    </div>
                    <div className={"p-col-12 p-lg-6 p-text-right"}>
                      {isInventoryDocumentEntity && (
                        <>
                          <small className={"p-text-uppercase"}>{props.t('columnSerialNumber')}</small>
                          <div className={"p-text-bold"}>{formData?.document_number || '—'}</div>
                        </>
                      )}
                      {/* {formData?.id && (
                        <>
                          <br/>
                          <small className={"p-text-uppercase"}>{props.t('columnIdentifier')}</small>
                          <div className={"p-text-bold"}>#{formData.id}</div>
                        </>
                      )} */}
                    </div>
                  </div>
                  <hr/>
                  <div className={"p-grid"} style={{rowGap: '0.75rem'}}>
                    <div className={"p-col-12 p-lg-6"}>
                      <small className={"p-text-uppercase"}>
                        {isInventoryCountView ? props.t('columnWarehouse') : props.t('targetWarehouse')}
                      </small>
                      <div className={"p-text-bold"}>
                        {(isInventoryCountView ? formData?.warehouse_from?.name : formData?.warehouse_to?.name) || '—'}
                      </div>
                    </div>
                    <div className={"p-col-12 p-lg-6"}>
                      <small className={"p-text-uppercase"}>{props.t('columnPartner')}</small>
                      <div className={"p-text-bold"}>{formData?.partner?.name || '—'}</div>
                      {formData?.shipping_address_snapshot && <div className="p-mt-2"><small>{props.t('fieldDeliveryAddress')}</small><div>{[formData.shipping_address_snapshot.country_code, formData.shipping_address_snapshot.postal_code, formData.shipping_address_snapshot.city, formData.shipping_address_snapshot.detail].filter(Boolean).join(' ')}</div></div>}
                    </div>
                    <div className={"p-col-12"}>
                      <small className={"p-text-uppercase"}>{props.t('columnDescription')}</small>
                      <div className={"p-text-bold"}>{formData?.description || '—'}</div>
                    </div>
                  </div>
                  <table className={"p-mt-2 w-100"} cellPadding={'6px'} cellSpacing={0}>
                    <tr>
                      <th className={"p-text-normal p-text-uppercase p-text-left"} style={{borderBottom: '1px solid #ccc'}}>
                        {props.t('columnName')}
                      </th>
                      <th className={"p-text-normal p-text-uppercase p-text-left"} style={{borderBottom: '1px solid #ccc'}}>
                        {props.t('quantity')}
                      </th>
                      <th className={"p-text-normal p-text-uppercase p-text-center"} style={{borderBottom: '1px solid #ccc'}}>
                        {t('upc')}
                      </th>
                      {/* {showWarehouseLocationToColumn && (
                        <th className={"p-text-normal p-text-uppercase p-text-right"} style={{borderBottom: '1px solid #ccc'}}>
                          {props.t('targetWarehouseLocation')}
                        </th>
                      )} */}
                    </tr>

                    {formData?.items && formData.items[0] ? (
                      formData.items.map((it, idx) => {
                        const name = it?.material?.name || '—';
                        const qty = `${Number(it?.quantity || 0)} ${it?.unit?.name || ''}`.trim() || '—';
                        // const loc = it?.warehouse_location_to?.code || '—';
                        return (
                          <React.Fragment key={idx}>
                            {/* <tr>
                               <td colSpan={showWarehouseLocationToColumn ? 3 : 2} style={{borderBottom: '1px solid #eee'}}>
                                <strong>{name}</strong>
                              </td>
                            </tr> */}
                            <tr>
                              <td style={{borderBottom: '1px solid #eee'}}>
                                <strong>{name}</strong>
                              </td>
                              <td style={{borderBottom: '1px solid #eee'}}>
                                {qty}
                              </td>
                              <td style={{borderBottom: '1px solid #eee'}} className='p-text-center'>
                                {it?.material?.upc || '—'}
                              </td>
                              {/* {showWarehouseLocationToColumn && (
                                <td className={"p-text-right"} style={{borderBottom: '1px solid #eee'}}>
                                  {loc}
                                </td>
                              )} */}
                            </tr>
                          </React.Fragment>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan={showWarehouseLocationToColumn ? 3 : 2}>
                          <small>{props.t('noItemRecorded')}</small>
                        </td>
                      </tr>
                    )}
                  </table>
                </Panel>
              </div>
            )}
          </div>
    </div>
  )
}
export default withTranslation('common')(InventorydocumentShowComponent);
